export default {
  workspaceCode: 'joayFevFvft75vpn',
};
